import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import PropTypes from 'prop-types';
import { TopicsList } from '../../../data/TopicsList';
import {Speaker} from "./Speaker";
import {SpeakersList} from "../../../data/speakersList";

export const SpeakerModal = ({ speaker, closeModal }) => {
  return (
    <>
      {speaker ? (
        <div className="snn-speaker-modal">
          <div className="snn-speaker-modal-top-bar">
            <span onClick={closeModal} className="snn-user-menu-icon material-symbols-outlined">
              close
            </span>
          </div>
          <div className="snn-speaker-modal-content">
            <div className="snn-speaker-modal-content-img-wrapper">
              <img src={speaker.img} alt={speaker.alt} />
            </div>
            <div className="snn-speaker-modal-content-main">
              <h2>{speaker.name}</h2>
              <p className="snn-speaker-modal-affiliation">{speaker.affiliation}</p>
              <p className="snn-speaker-resume">{speaker.resume}</p>
              {speaker.abstract ? (
                <>
                  <hr />
                  <h2>{speaker.title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: speaker.abstract }} />
                </>
              ) : null}
            </div>
            {speaker.topic_id ? (
              <div className="snn-speaker-modal-content-bottom">
                <h3>Topic</h3>
                <div>
                  <p>{TopicsList.filter((t) => t.id === speaker.topic_id)[0].name}</p>
                  <img src={TopicsList.filter((t) => t.id === speaker.topic_id)[0].src_shield} />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

export const SpeakersWrapper = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h2 className="snn-title">Speakers</h2>
            <div className="snn-speakers-cards-wrapper">
                {SpeakersList.map((speaker) => (
                    <Speaker
                        speaker={speaker}
                        key={speaker.id}
                        handleClick={() => {}}
                    />
                ))}
            </div>
        </section>
      </div>
        <Footer/>
    </>
  );
};

SpeakerModal.propTypes = {
    speaker: PropTypes.any.isRequired,
    closeModal: PropTypes.func,
};
